import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'roleChecker'})

export class RoleChecker implements PipeTransform {
    transform(userRoles: string[] = [], checkForRoles: string[] = []): any {
        return userRoles.some((role: any) => checkForRoles.includes(role));
    }
}
